import React__default from 'react';
import { Text } from '@amzn/storm-ui';
import { h as PromptContainer } from './FormLayout.styles-BzYy_4z2.js';

const FormLayoutPrompt = ({
  renderPrompt
}) => renderPrompt ? /*#__PURE__*/React__default.createElement(PromptContainer, null, typeof renderPrompt === 'function' ? renderPrompt() : /*#__PURE__*/React__default.createElement(Text, {
  type: "h1",
  styleAs: "h4",
  fontSize: "base",
  textColor: "base"
}, renderPrompt)) : null;

export { FormLayoutPrompt as F };
//# sourceMappingURL=FormLayoutPrompt-iACIoUki.js.map
